import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { FetchProvider} from "./components/common/FetchProvider";
import "./index.css";
import App from "./routes/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
      <FetchProvider>
          <App />
      </FetchProvider>
  </BrowserRouter>
);
